import { Injectable } from '@angular/core';
import { Userstory } from '../models/userstory';

@Injectable({
  providedIn: 'root'
  })
export class ScrumUtilsService {

  constructor() { }


  // TODO remove reliance on hardcoded columnname!
  /**
   * This function calculates the velocity (sum of estimates) of a list of user stories
   * @param userstories
   */
  getVelocityOfUserstories(userStories: Userstory[]): number {
    let velocity = 0;
    for (const userStory of userStories) {
      if (userStory.status.name === 'Done') {
        velocity += userStory.estimate;
      }
    }

    return velocity;
  }

  /**
   * This function takes a velocity value and performs autoplanning on an array of user stories.
   * It takes a number of user stories from the top (start of array) and puts them into a new array.
   * The number of user stories in the new arra depend on the velocity
   * This function assumes that the estimate of the user story is not be empty (0).
   * @param velocity
   * @param userStories
   */
  getAutoplannedUserstories(velocity: number, userStories: Userstory[]): Userstory[] {
    const autoplannedUserstories: Userstory[] = [];
    for (const userStory of userStories) {
      if (userStory.estimate && (velocity = velocity - userStory.estimate) >= 0) {
        autoplannedUserstories.push(userStory);
      } else {
        break;
      }
    }

    return autoplannedUserstories;
  }
}
